var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Input } from "./Input";
import { validateStreetAddress, validatePostalCode, validateAddressCity } from "./validation";
import { SelectAddressType } from "./SelectAddressType";
import { AddressType } from "./admin-gql";
import i18next from "i18next";
var AddressControl = /** @class */ (function (_super) {
    __extends(AddressControl, _super);
    function AddressControl(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.state = {
            showAllFields: !!(props.address.co || props.address.country)
        };
        return _this;
    }
    AddressControl.prototype.render = function () {
        var _this = this;
        var address = this.props.address;
        var disabled = this.props.disabled;
        var readonly = this.props.readonly || this.props.address.type === AddressType.OFFICIAL;
        var commonProps = {
            readonly: readonly,
            disabled: disabled
        };
        var onChange = function (partial) {
            if (_this.props.onChange) {
                return _this.props.onChange(__assign(__assign({}, address), partial));
            }
        };
        var forceValidationErrors = this.props.forceShowValidationErrors;
        return (React.createElement("div", { className: this.props.className },
            address.type !== AddressType.OFFICIAL ? (React.createElement("div", { className: "form-row" },
                React.createElement("div", { className: "form-group col-2" },
                    React.createElement(SelectAddressType, __assign({ readonly: readonly, onChange: function (x) { return onChange({ type: x }); }, type: address.type }, commonProps))),
                React.createElement("div", { className: "form-group col d-flex align-items-center" }, address.primary ? i18next.t("cc.address.control.primaryAddress") : null))) : (React.createElement("div", { className: "form-group" },
                React.createElement("input", { type: "text", readOnly: true, className: "form-control-plaintext bg-secondary p-2", value: i18next.t("cc.address.control.officialAddress") }))),
            React.createElement("div", { className: "form-row" },
                React.createElement("div", { className: "form-group col-6" },
                    React.createElement(Input, __assign({ forceShowValidationError: forceValidationErrors, onChange: function (newStr) { return onChange({ streetAddress: newStr }); }, validationErrorMessage: validateStreetAddress(address.streetAddress), value: address.streetAddress, placeholder: i18next.t("cc.address.control.address"), readonly: readonly, autoFocus: this.props.autoFocus }, commonProps))),
                React.createElement("div", { className: "form-group col-6" },
                    React.createElement(Input, __assign({ forceShowValidationError: forceValidationErrors, onChange: function (newStr) { return onChange({ apartmentNumber: newStr }); }, value: address.apartmentNumber, placeholder: i18next.t("cc.address.control.apartmentnumber") }, commonProps)))),
            this.state.showAllFields ? (React.createElement("div", { className: "form-group" },
                React.createElement(Input, __assign({ forceShowValidationError: forceValidationErrors, onChange: function (x) { return onChange({ co: x }); }, value: address.co, placeholder: i18next.t("cc.address.control.co") }, commonProps)))) : null,
            React.createElement("div", { className: "form-row" },
                React.createElement("div", { className: "form-group col-6" },
                    React.createElement(Input, __assign({ forceShowValidationError: forceValidationErrors, onChange: function (x) { return onChange({ postalCode: x }); }, validationErrorMessage: validatePostalCode(address.postalCode), value: address.postalCode, placeholder: i18next.t("cc.address.control.postcode") }, commonProps))),
                React.createElement("div", { className: "form-group col-6" },
                    React.createElement(Input, __assign({ forceShowValidationError: forceValidationErrors, onChange: function (x) { return onChange({ city: x }); }, validationErrorMessage: validateAddressCity(address.city), value: address.city, placeholder: i18next.t("cc.address.control.city") }, commonProps)))),
            this.state.showAllFields ? (React.createElement("div", { className: "form-group" },
                React.createElement(Input, __assign({ forceShowValidationError: forceValidationErrors, onChange: function (x) { return onChange({ country: x }); }, value: address.country, placeholder: i18next.t("cc.address.control.country") }, commonProps)))) : null,
            address.type !== AddressType.OFFICIAL && !readonly ? (React.createElement("div", { className: "d-flex justify-content-end" },
                React.createElement("div", null,
                    !address.primary ? (React.createElement("button", { className: "btn btn-link p-0", onClick: function () { return onChange({ primary: true }); } }, i18next.t("cc.address.control.makeItPrimary"))) : null,
                    "\u00A0\u00A0",
                    React.createElement("button", { className: "btn btn-link p-0", onClick: function () { return _this.setState(function (s) { return ({ showAllFields: !s.showAllFields }); }); } }, this.state.showAllFields ? i18next.t("cc.address.control.hideFields") : i18next.t("cc.address.control.showMoreFields")),
                    "\u00A0\u00A0",
                    React.createElement("button", { className: "btn btn-link p-0", onClick: function () {
                            if (_this.props.onRemove) {
                                _this.props.onRemove(address);
                            }
                        } }, i18next.t("cc.address.control.remove"))))) : null));
    };
    return AddressControl;
}(React.Component));
export { AddressControl };
//# sourceMappingURL=AddressControl.js.map